import React from 'react';
import PostRefreshReminderWidget from './PostRefreshReminderWidget';

const PostRefreshReminderWidgetBasic = () => (
  <PostRefreshReminderWidget className="masonry-item w-[440px] h-[250px] flex flex-col" />
);

export default PostRefreshReminderWidgetBasic;
